import { render, staticRenderFns } from "./PendenciasTecnico.vue?vue&type=template&id=4bfb75a4&scoped=true&lang=pug&"
import script from "./PendenciasTecnico.vue?vue&type=script&lang=js&"
export * from "./PendenciasTecnico.vue?vue&type=script&lang=js&"
import style0 from "./PendenciasTecnico.vue?vue&type=style&index=0&id=4bfb75a4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb75a4",
  null
  
)

export default component.exports